import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://bhlxxmnnlrhexoxdynfn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJobHh4bW5ubHJoZXhveGR5bmZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ3Mjg5NzcsImV4cCI6MjA0MDMwNDk3N30.gO53UIm2D2jNmgs2crNPcx4M5AgU83ndA9GNOjhjFyc';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);